/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

import FaxosaurusFormPreview from './faxosaurus-form-preview';
/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save( { attributes } ) {

	const { fxid, surveyJson, customQuestions, surveyElement } = attributes;

	return (
		<div { ...useBlockProps.save() }>
			<FaxosaurusFormPreview surveyJson={surveyJson} />
		</div>
	);
}
